export default (that) => [
  {
    text: that.$l('menu_text_detailFabric') || '查看面料',
    icon: 'el-icon-view',
    menuType: 'detail',
    divided: false,
  },
  {
    text: that.$l('menu_text_editFabric') || '编辑面料',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: false,
    visible: !that.disabled,
  },
  {
    text: that.$l('menu_text_copyFabric') || '复制面料',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    divided: true,
    visible: !that.disabled,
  },
  {
    text: that.$l('menu_text_delFabric') || '删除面料',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    visible: !that.disabled,
  },
]
